export default {"src":"/_next/static/media/state-farm.bd74608f.svg","height":48,"width":239,"blurWidth":0,"blurHeight":0};